import React, { ReactNode } from 'react';
import './NonInputsContainer.css';

interface INonInputsContainerProps {
    children: ReactNode;
}

export default function NonInputsContainer({
    children,
}: INonInputsContainerProps) {
    return <div className='Pqde-NonInputsContainer'>{children}</div>;
}
